import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { showToast } from "../utils/toast";
import { parseError } from "../utils";

const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {},
  },
  queryCache: new QueryCache({
    onError: (error: unknown) => {
      const message = parseError(error);

      showToast(message, "error");
    },
  }),
});

type Props = {
  children: React.ReactNode;
};

const QueryProvider = ({ children }: Props) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.NODE_ENV === "development" && (
        <ReactQueryDevtools position="bottom-right" />
      )}
    </QueryClientProvider>
  );
};

export default QueryProvider;
